<template>
    <el-dialog title="行驶证信息" :visible.sync="dialogVisible" width="740px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="行驶证正页" prop="drivingLicenseFront">
                        <up-img :file.sync="form.drivingLicenseFront" width="200" height="154"></up-img>
                    </el-form-item>
                    <el-form-item label="行驶证副页" prop="drivingLicenseBack">
                        <up-img :file.sync="form.drivingLicenseBack" width="200" height="154"></up-img>
                    </el-form-item>
                    <el-form-item label="车辆照片" prop="vehiclePhoto">
                        <up-img :file.sync="form.vehiclePhoto" width="200" height="135"></up-img>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="车辆识别代号" prop="vin">
                        <el-input v-model="form.vin" placeholder="请输入车辆识别代号" maxlength="17"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆号牌" prop="licenseNo">
                        <el-input v-model="form.licenseNo" placeholder="请输入车辆号牌码" maxlength="8"></el-input>
                    </el-form-item>
                    <el-form-item label="号牌颜色" prop="licenseColor">
                        <el-select v-model="form.licenseColor" filterable>
                            <el-option v-for="item in $const.LICENSECOLOR" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用性质" prop="useCharacter">
                        <el-select v-model="form.useCharacter" filterable>
                            <el-option v-for="item in useCharacterOptions" :label="item.label" :key="item.value"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="核载人数" prop="vehicleSeat">
                        <el-select v-model="form.vehicleSeat" filterable>
                            <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="注册日期" prop="registerDate">
                        <el-date-picker v-model="form.registerDate" :picker-options="pickerOptions" type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="车辆型号" prop="vehicleModel">
                        <el-input v-model="form.vehicleModel" placeholder="请输入车辆型号" :maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="车身颜色" prop="vehicleColor">
                        <el-select v-model="form.vehicleColor">
                            <el-option v-for="item in $const.VEHICLECOLOR" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车辆编号" prop="vehicleNo">
                        <el-input v-model="form.vehicleNo" placeholder="请输入车辆编号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let vinValidator = (rule, value, callback) => {
            var regu = /^[A-HJ-NPR-Z\d]{17}$/;
            var re = new RegExp(regu);
            if (!value) {
                callback(new Error("请输入车辆识别代号"));
            } else if (!re.test(value)) {
                callback(new Error("请输入正确的车辆识别代号"));
            } else {
                callback();
            }
        };
        return {
            dialogVisible: false,
            pickerOptions: {
                disabledDate(time) {
                    // 禁用今日之后的日期
                    return time.getTime() < new Date('1949-10-01 00:00:00') || time.getTime() > Date.now(); // 8.64e7 毫秒数代表一天
                },
            },
            form: {
                drivingLicenseFront: '',
                drivingLicenseBack: '',
                vin: '',
                licenseNo: '',
                licenseColor: '',
                useCharacter: '',
                vehicleSeat: '',
                registerDate: '',
                vehiclePhoto: '',
                vehicleModel: '',
                vehicleColor: '',
                vehicleNo: ''
            },
            rules: {
                drivingLicenseFront: [
                    { required: true, message: '请上传驾驶证正本' }
                ],
                drivingLicenseBack: [
                    { required: true, message: '请上传驾驶证副本' }
                ],
                vin: [
                    { required: true, validator: vinValidator }
                ],
                licenseNo: [
                    { required: true, message: '请输入车辆号牌码' }
                ],
                licenseColor: [
                    { required: true, message: '请选择号牌颜色' }
                ],
                useCharacter: [
                    { required: true, message: '请选择使用性质' }
                ],
                vehicleSeat: [
                    { required: true, message: '请选择核载人数' }
                ],
                registerDate: [
                    { required: true, message: '请选择注册日期' }
                ],
                vehiclePhoto: [
                    { required: true, message: '请上传车辆照片' }
                ],
                vehicleModel: [
                    { required: true, message: '请输入车辆型号' }
                ],
                vehicleColor: [
                    { required: true, message: '请选择车身颜色' }
                ],
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    computed: {
        useCharacterOptions() {
            return this.mixinUserInfo.platformType == 1 || this.mixinUserInfo.platformType == 2 ? this.$const.CUSTOMUSENATURE : this.$const.USENATURE;
        }
    },
    methods: {
        initForm() {
            this.form = {
                drivingLicenseFront: this.info.drivingLicenseFront || '',
                drivingLicenseBack: this.info.drivingLicenseBack || '',
                vin: this.info.vin || '',
                licenseNo: this.info.licenseNo || '',
                licenseColor: this.info.licenseColor || '',
                useCharacter: this.info.useCharacter || '',
                vehicleSeat: this.info.vehicleSeat || '',
                registerDate: this.info.registerDate ? this.$utils.timeFn(this.info.registerDate * 1000, "YYYY-MM-DD") : '',
                vehiclePhoto: this.info.vehiclePhoto || '',
                vehicleModel: this.info.vehicleModel || '',
                vehicleColor: this.info.vehicleColor || '',
                vehicleNo: this.info.vehicleNo || ''
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', {
                        ...this.form,
                        registerDate: this.form.registerDate ? new Date(this.form.registerDate).getTime() / 1000 : null
                    });
                }
            });
        }
    }
}
</script>
